export default "__VITE_ASSET__872da825__"